import { render, staticRenderFns } from "./ChangeTeamStatusModal.vue?vue&type=template&id=71fe744d&"
import script from "./ChangeTeamStatusModal.vue?vue&type=script&lang=js&"
export * from "./ChangeTeamStatusModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71fe744d')) {
      api.createRecord('71fe744d', component.options)
    } else {
      api.reload('71fe744d', component.options)
    }
    module.hot.accept("./ChangeTeamStatusModal.vue?vue&type=template&id=71fe744d&", function () {
      api.rerender('71fe744d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Billing/components/ChangeTeamStatusModal.vue"
export default component.exports